var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph"},[_c('apexchart',{attrs:{"options":_vm.graph_options,"series":_vm.graph_series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }